<template>
  <div class="ts-menu-item">
    <router-link :to="to" :class="{ exact, lenient: !exact }">
      <div class="icon">
        <slot name="icon"></slot>
      </div>
      <slot></slot>
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
.ts-menu-item {
  font-family: Roboto;
  font-size: 16px;
  color: #6d7587;

  padding-left: 16px;

  .icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }

  a {
    display: block;
    padding: 2px 0 2px 0;
    margin: 4px 0;
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
    text-decoration: none;
    border: 1px solid transparent;

    &.router-link-exact-active.exact {
      color: #33373d;
    }

    &.router-link-active.lenient {
      color: #33373d;
    }
  }
}
</style>

<script>
export default {
  name: 'TsMenuSubItem',
  props: {
    to: {
      type: Object,
      default: () => ({ name: 'home' })
    }
  },
  computed: {
    exact() {
      return this.to.name === 'home';
    }
  }
};
</script>
